import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { FileText, CalendarCheck, Building2, ArrowRight } from "lucide-react";
import Sidebar from "../components/Sidebar";
import { COMUNICAZIONI_SUB } from "../mock";
import { fetchComunicazioni } from "../api";

const SubSection = ({ sub, items, icon: Icon }) => (
  <div className="mb-10">
    <div className="flex items-center gap-2 mb-4">
      <Icon className="text-sq-orange" size={20} />
      <h2 className="font-serif-display text-2xl text-sq-navy">{sub.name}</h2>
    </div>
    <div className="border border-sq rounded-sm divide-y divide-[#e6e8ec]">
      {items.map((it) => (
        <Link
          key={it.id}
          to={`/comunicazioni/${sub.slug}/${it.slug}`}
          className="group flex items-start gap-4 px-5 py-4 hover:bg-sq-light transition-colors"
        >
          <div className="w-10 h-10 rounded-sm bg-sq-light border border-sq flex items-center justify-center flex-shrink-0">
            <Building2 size={18} className="text-sq-navy" />
          </div>
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <span className="text-[11px] uppercase tracking-wide text-sq-orange font-semibold">
                {it.company}
              </span>
              <span className="text-xs text-gray-400">· {it.date}</span>
            </div>
            <h3 className="font-medium text-sq-navy article-title-hover leading-snug">{it.title}</h3>
            <p className="text-sm text-gray-600 mt-1">{it.summary}</p>
          </div>
          <ArrowRight size={18} className="text-gray-300 group-hover:text-sq-orange transition-colors mt-1" />
        </Link>
      ))}
      {items.length === 0 && (
        <div className="px-5 py-6 text-sm text-gray-500">Nessuna comunicazione disponibile.</div>
      )}
    </div>
  </div>
);

const ComunicazioniPage = () => {
  const { sub } = useParams();
  const [items, setItems] = useState([]);
  const icons = {
    "avvisi-convocazione": CalendarCheck,
    "deposito-relazioni": FileText,
  };

  useEffect(() => {
    fetchComunicazioni(sub)
      .then(setItems)
      .catch(() => setItems([]));
  }, [sub]);

  const subsToShow = sub
    ? COMUNICAZIONI_SUB.filter((s) => s.slug === sub)
    : COMUNICAZIONI_SUB;

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 fade-in">
      <div className="flex items-center gap-2 text-sm text-gray-500 mb-6">
        <Link to="/" className="hover:text-sq-orange">Home</Link>
        <span>/</span>
        <Link to="/comunicazioni" className="hover:text-sq-orange">Comunicazioni societarie</Link>
      </div>

      <h1 className="font-serif-display text-4xl text-sq-navy mb-2">Comunicazioni societarie</h1>
      <p className="text-gray-600 mb-4 max-w-2xl">
        Pubblicazione automatica e strutturata degli avvisi ufficiali e dei documenti periodici delle
        società quotate, da fonti ufficiali.
      </p>
      <div className="w-16 h-1 bg-sq-orange mb-8" />

      <div className="flex flex-wrap gap-3 mb-8">
        <Link
          to="/comunicazioni"
          className={`px-4 py-2 text-sm rounded-sm border transition-colors ${
            !sub ? "bg-sq-orange text-white border-sq-orange" : "border-sq text-sq-navy hover:border-sq-orange"
          }`}
        >
          Tutte
        </Link>
        {COMUNICAZIONI_SUB.map((s) => (
          <Link
            key={s.slug}
            to={`/comunicazioni/${s.slug}`}
            className={`px-4 py-2 text-sm rounded-sm border transition-colors ${
              sub === s.slug ? "bg-sq-orange text-white border-sq-orange" : "border-sq text-sq-navy hover:border-sq-orange"
            }`}
          >
            {s.name}
          </Link>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2">
          {subsToShow.map((s) => (
            <SubSection
              key={s.slug}
              sub={s}
              items={items.filter((i) => i.subSlug === s.slug)}
              icon={icons[s.slug]}
            />
          ))}
        </div>
        <Sidebar showBottomAd={false} />
      </div>
    </div>
  );
};

export default ComunicazioniPage;
